import { useSetAtom } from 'jotai';

import type { ImageAnalyses } from '../../../../@types/latestImagesV2';
import type { TClaimMessage } from '../../../../@types/rcm';
import { usePreferences } from '../../../../react-query/usePreferences';
import type { TSummaryTreatment } from '../hooks/useSummary';
import { insPagesAtom } from '../state';

import { ImageInfo } from './ImageInfo';
import { PatientInfo } from './PatientInfo';

export type SummaryConfigProps = {
  images: ImageAnalyses[];
  filteredTeethList: string[];
  defaultTeethList: string[];
  estimatedVisitId: number;
  unifiedAppointmentId?: number;
  isSrp: boolean;
  defaultTreatments: TSummaryTreatment[];
  treatmentsToUse: TSummaryTreatment[];
  radiographsTakenDate: string;
  messages: TClaimMessage[];
  onSelectTreatments: (txIds: string[]) => void;
  onSelectBitewingOnly: (isBitewingOnly: boolean) => void;
};

export function SummaryConfig({
  estimatedVisitId,
  unifiedAppointmentId,
  isSrp,
  defaultTreatments,
  treatmentsToUse,
  radiographsTakenDate,
  messages,
  onSelectTreatments,
  onSelectBitewingOnly,
}: SummaryConfigProps) {
  const { data: preferences } = usePreferences();

  const setInsPage = useSetAtom(insPagesAtom);

  return (
    <div className="vai-grid vai-grid-cols-[1fr_1fr] vai-gap-4 vai-h-full">
      <div className="vai-p-4 vai-rounded-lg">
        <PatientInfo
          preferences={preferences}
          estimatedVisitId={estimatedVisitId}
          unifiedAppointmentId={unifiedAppointmentId}
          defaultTreatments={defaultTreatments}
          treatmentsToUse={treatmentsToUse}
          isSrp={isSrp}
          onSelectTreatments={onSelectTreatments}
          onSetInsPage={(page) => setInsPage(page)}
        />
      </div>
      <div className="vai-p-4 vai-rounded-lg">
        <ImageInfo
          onSelectBitewingOnly={onSelectBitewingOnly}
          radiographsTakenDate={radiographsTakenDate}
          messages={messages}
        />
      </div>
    </div>
  );
}
